import React, { useEffect, useState } from "react";
import { Button, Form, Alert } from "react-bootstrap";
import styles from "./MainProfile.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import config from "../../../settings/config";
import { useToast } from "../../../context/ToastContext";
import useAuthToken from "../../../hooks/useAuthToken";
import backArrow from "../../../img/backArrow.png";
import { getProfile } from "./fetchMainProfile";
import CustomModal from '../../utils/CustomModal';

const MainProfile = () => {
    const navigate = useNavigate();
    const [profile, setProfile] = useState();
    const { setToast } = useToast();
    const token = useAuthToken();
    const [showModal, setShowModal] = useState(false);

    const showToast = (message, type, time) => {
        setToast({ message, type });
        setTimeout(() => setToast(null), time);
    };

    useEffect(() => {
        fetchProfile();
    }, []);

    async function fetchProfile() {
        if (!token) return;
        const resp = await getProfile(token);
        if (resp) setProfile(resp);
    }

    console.log(profile)

    const handleLogOut = () => {
        setShowModal(true);
    };

    const confirmLogout = () => {
        localStorage.removeItem('token');
        navigate('/');
    }

    

    const handleChangeProfile = () => {

    }

    const handleChangeSettings = () => {

    }

    const handleBack = () => {
        navigate(-1);
    }

    return (
        <div className={styles.container}>
            <div className={styles.mainSection}>
                <h3>Профиль</h3>
                <button
                    className={styles.buttonLogout}
                    onClick={handleChangeProfile}
                >
                    Изменить профиль
                </button>
                <button
                    className={styles.buttonLogout}
                    onClick={handleChangeSettings}
                >
                    Настройки приложения
                </button>
                


            </div>
            <div className={styles.button}>
                <div className={styles.buttonsBg}>
                    <button
                        className={styles.buttonBack}
                        onClick={handleBack}
                    >
                        <img className={styles.backArrow} src={backArrow} alt="backArrow"></img>
                    </button>
                    <button
                        className={styles.buttonAdd}
                        onClick={handleLogOut}
                    >
                        Выйти из аккаунта
                    </button>
                </div>
                <CustomModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    onConfirm={confirmLogout}
                    textMsg="Выход из аккаунта"
                    textQuestions="Вы действительно хотите выйти из аккаунта?"
                    yes="Да"
                    no="Нет"
                />
            </div>
            
        </div>
    );
};

export default MainProfile;
